import { queryOptions } from "@tanstack/react-query";
import api from "~/shared/api/core/api";
import { EventDetailResponse } from "~/shared/api/events/events.types";
import { Params } from "~/shared/api/types/params";
import { PaginatedResponse } from "~/shared/types/pagination.types";

export const EVENT_KEYS = {
  all: ["event"] as const,
  detail: (eventId: number) => [...EVENT_KEYS.all, eventId] as const,
  attendees: (eventId: number, params: Params) => [...EVENT_KEYS.detail(eventId), "attendies", params] as const,
  categories: () => [...EVENT_KEYS.all, "categories"] as const,
  categoriesList: (params: Params) => [...EVENT_KEYS.categories(), params] as const,
} as const;

export const EVENT_QUERIES = {
  detail: (eventId: number) => {
    return queryOptions({
      queryKey: EVENT_KEYS.detail(eventId),
      queryFn: async ({ signal }) => {
        const response = await api.get<EventDetailResponse>(`/events/${eventId}`, { signal });

        return response.data;
      },
    });
  },
  attendees: (eventId: number, params: Params) => {
    return queryOptions({
      queryKey: EVENT_KEYS.attendees(eventId, params),
      queryFn: async ({ signal }) => {
        const response = await api.get<EventDetailResponse>(`/events/${eventId}/participants`, {
          ...params,
          signal,
        });

        return response.data;
      },
    });
  },
  categories: (params: Params) => {
    return queryOptions({
      queryKey: EVENT_KEYS.categoriesList(params),
      queryFn: async ({ signal }) => {
        const response = await api.get<
          PaginatedResponse<{
            id: number;
            name: string;
          }>
        >(`/events/categories`, {
          ...params,
          signal,
        });

        return response.data;
      },
    });
  },
} as const;
